import { useFormikContext } from "formik";
import { DisplayFormErrors, InputField, VerticalForm, } from "melco-shared-logic";
import { Col, Row, DesignTokens, FormSection, FormRow, Paragraph } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEffect, useState } from "react";
import AntdForm from "antd/es/form";
import { StatesSelect } from "../../common/StatesSelect";
import { GenderSelect } from "../../common/GenderSelect";
import { AddProfileConfirmButton } from "../AddProfileConfirmButton";
import RegisterUserCountrySelect from "../../common/RegisterUserCountrySelect";
import EmailFieldWithAvailabilityCheck from "../../common/EmailFieldWithAvailabilityCheck";


const { spacings } = DesignTokens;

const StyledFormItem = styled(AntdForm.Item)`
  margin-bottom: ${spacings.middle}px;

  .ant-form-item-label {
    padding-bottom: ${spacings.xsmall}px;
  }
`;


type DisplayAddUserFormProps = {
}



export const DisplayAddUserForm: React.FC<DisplayAddUserFormProps> = () => {
    const { t } = useTranslation();
    const { setFieldValue, values } = useFormikContext();
    const [formFields, setFields] = useState<any>(values);

    useEffect(() => {
        setFields(values);
    }, [values])

    return (
        <>

            <div>


                <VerticalForm>
                    <DisplayFormErrors />




                    <FormSection title={t("users.profiledetails.personal_information")}>

                        <StyledFormItem>
                            <span> {t("users.profiledetails.gender")}</span>


                            <GenderSelect
                                value={formFields.gender_code?.toString() ?? undefined}
                                name="gender_code"
                                //selectedCountry={formFields?.address?.country_code ?? undefined}
                                onChange={(value) => {



                                    setFieldValue("gender_code", value)

                                }}

                            />
                        </StyledFormItem>

                        <InputField
                            name="first_name"
                            label={t("users.profiledetails.first_name")}

                        />

                        <InputField
                            name="last_name"
                            label={t("users.profiledetails.last_name")}

                        />

                        <Row gutter={[spacings.middle, 0]}>
                            <Col xs={24} md={12}>
                                    <InputField
                                        name="account_name"
                                        label={t("users.profiledetails.account_name")}
                                        style={{"minHeight":"40px"}}
                                    />
                            </Col>
                            <Col xs={24} md={12}>
                               
                                 <EmailFieldWithAvailabilityCheck
                                    name="email"
                                    label={t("users.create.username_email")}
                                    placeholder={t("global.form.profile.email")}
                                />
                            </Col>
                        </Row>

                       


                     
                        <InputField
                            name="password"
                            size="large"
                            label={t("users.create.password")}
                            //  placeholder={t("global.form.label.profile.password")}
                            type="password"
                            autoComplete="current-password"
                        />
                     
                        <InputField
                            name="confirm_password"
                            size="large"
                            label={t("users.create.confirm_password")}
                            //placeholder={t("global.form.label.profile.confirm_password")}
                            type="password"
                            autoComplete="confirm"
                        />
                       
                        <Paragraph size="small" type="secondary">
                            {t("global.hint.password_requirements")}
                        </Paragraph>
                        <InputField
                                    name="company_name"
                                    label={t("users.profiledetails.company_name")}
                                  
                                />

                        <Row gutter={[spacings.middle, 0]}>
                            <Col xs={24} md={12}>
                                <InputField
                                    name="phone"
                                    label={t("users.profiledetails.phone")}

                                />

                            </Col>
                            <Col xs={24} md={12}>
                                <InputField
                                    name="website"
                                    label={t("users.profiledetails.website")}

                                />

                            </Col>
                        </Row>
                    </FormSection>
                    <FormSection title={t("users.profiledetails.address_information")} >


                        <InputField
                            name="address.street1"
                            label={t("users.profiledetails.street1")}

                        />




                        <InputField
                            name="address.street2"
                            label={t("users.profiledetails.street2")}

                        />

                        <InputField
                            name="address.postal_code"
                            label={t("users.profiledetails.postal_code")}
                        // value={UserDetails?.address?.postal_code ?? ""}

                        />
                        <InputField
                            name="address.city"
                            label={t("users.profiledetails.city")}

                        />
                      
                        <RegisterUserCountrySelect
                            label={t("users.profiledetails.country")}
                            name="address.country_code" />

                        <StyledFormItem>
                            <span> {t("users.profiledetails.state")}</span>
                            <StatesSelect
                                value={formFields?.address?.state_code?.toString() ?? undefined}
                                name="address.state_code"
                                selectedCountry={formFields?.address?.country_code ?? undefined}
                                onChange={(value) => {



                                    setFieldValue("address.state_code", value)

                                }}

                            /></StyledFormItem>
                    </FormSection>
                    {
                        <FormRow justify="end">
                            <AddProfileConfirmButton />

                        </FormRow>
                    }

                </VerticalForm>
            </div>
        </>

    );
};
